import { render, staticRenderFns } from "./FlightIndex.vue?vue&type=template&id=385c6a44&"
import script from "./FlightIndex.vue?vue&type=script&lang=js&"
export * from "./FlightIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports